export var CTADeviceNames;

(function (CTADeviceNames) {
  CTADeviceNames["desktop"] = "desktop";
  CTADeviceNames["mobile"] = "mobile";
  CTADeviceNames["nativeIOS"] = "nativeIOS";
  CTADeviceNames["nativeAndroid"] = "nativeAndroid";
})(CTADeviceNames || (CTADeviceNames = {}));

export var NAVIGATION_TARGETS;

(function (NAVIGATION_TARGETS) {
  NAVIGATION_TARGETS["BLANK"] = "_blank";
  NAVIGATION_TARGETS["SELF"] = "_self";
})(NAVIGATION_TARGETS || (NAVIGATION_TARGETS = {}));

export var CtaSectionType;

(function (CtaSectionType) {
  CtaSectionType["CTA"] = "CTA";
  CtaSectionType["OPTIN"] = "Opt-in";
  CtaSectionType["SELECTIONS"] = "Markets/Offers";
})(CtaSectionType || (CtaSectionType = {}));

export var ImageResolution;

(function (ImageResolution) {
  ImageResolution["HIGH"] = "high";
  ImageResolution["MEDIUM"] = "medium";
  ImageResolution["LOW"] = "low";
})(ImageResolution || (ImageResolution = {}));

export var AdobeDeviceNames;

(function (AdobeDeviceNames) {
  AdobeDeviceNames["desktop"] = "desktop";
  AdobeDeviceNames["mobile"] = "mobile";
  AdobeDeviceNames["tablet"] = "tablet";
})(AdobeDeviceNames || (AdobeDeviceNames = {}));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9lbnVtcy50cyJdLCJuYW1lcyI6WyJDVEFEZXZpY2VOYW1lcyIsIk5BVklHQVRJT05fVEFSR0VUUyIsIkN0YVNlY3Rpb25UeXBlIiwiSW1hZ2VSZXNvbHV0aW9uIiwiQWRvYmVEZXZpY2VOYW1lcyJdLCJtYXBwaW5ncyI6IkFBQUEsV0FBWUEsY0FBWjs7V0FBWUEsYztBQUFBQSxFQUFBQSxjO0FBQUFBLEVBQUFBLGM7QUFBQUEsRUFBQUEsYztBQUFBQSxFQUFBQSxjO0dBQUFBLGMsS0FBQUEsYzs7QUFPWixXQUFZQyxrQkFBWjs7V0FBWUEsa0I7QUFBQUEsRUFBQUEsa0I7QUFBQUEsRUFBQUEsa0I7R0FBQUEsa0IsS0FBQUEsa0I7O0FBS1osV0FBWUMsY0FBWjs7V0FBWUEsYztBQUFBQSxFQUFBQSxjO0FBQUFBLEVBQUFBLGM7QUFBQUEsRUFBQUEsYztHQUFBQSxjLEtBQUFBLGM7O0FBTVosV0FBWUMsZUFBWjs7V0FBWUEsZTtBQUFBQSxFQUFBQSxlO0FBQUFBLEVBQUFBLGU7QUFBQUEsRUFBQUEsZTtHQUFBQSxlLEtBQUFBLGU7O0FBWVosV0FBWUMsZ0JBQVo7O1dBQVlBLGdCO0FBQUFBLEVBQUFBLGdCO0FBQUFBLEVBQUFBLGdCO0FBQUFBLEVBQUFBLGdCO0dBQUFBLGdCLEtBQUFBLGdCIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGVudW0gQ1RBRGV2aWNlTmFtZXMge1xuICBkZXNrdG9wID0gJ2Rlc2t0b3AnLFxuICBtb2JpbGUgPSAnbW9iaWxlJyxcbiAgbmF0aXZlSU9TID0gJ25hdGl2ZUlPUycsXG4gIG5hdGl2ZUFuZHJvaWQgPSAnbmF0aXZlQW5kcm9pZCcsXG59XG5cbmV4cG9ydCBlbnVtIE5BVklHQVRJT05fVEFSR0VUUyB7XG4gIEJMQU5LID0gJ19ibGFuaycsXG4gIFNFTEYgPSAnX3NlbGYnLFxufVxuXG5leHBvcnQgZW51bSBDdGFTZWN0aW9uVHlwZSB7XG4gIENUQSA9ICdDVEEnLFxuICBPUFRJTiA9ICdPcHQtaW4nLFxuICBTRUxFQ1RJT05TID0gJ01hcmtldHMvT2ZmZXJzJyxcbn1cblxuZXhwb3J0IGVudW0gSW1hZ2VSZXNvbHV0aW9uIHtcbiAgSElHSCA9ICdoaWdoJyxcbiAgTUVESVVNID0gJ21lZGl1bScsXG4gIExPVyA9ICdsb3cnLFxufVxuXG4vKipcbiAqIEBkZXByZWNhdGVkXG4gKlxuICogUGxlYXNlIHVzZSBDVEFEZXZpY2VOYW1lcyBpbnN0ZWFkXG4gKiBUaGlzIHdpbGwgYmUgcmVtb3ZlZCBpbiB0aGUgZnV0dXJlXG4gKi9cbmV4cG9ydCBlbnVtIEFkb2JlRGV2aWNlTmFtZXMge1xuICBkZXNrdG9wID0gJ2Rlc2t0b3AnLFxuICBtb2JpbGUgPSAnbW9iaWxlJyxcbiAgdGFibGV0ID0gJ3RhYmxldCcsXG59XG4iXX0=